import { useEffect } from "@/common/hooks";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import Routes from "@/routes/RouteComponent";
import { logout } from "@/store/store";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate(Routes.login.path); // ✅ redirect after clearing state
  };
  useEffect(() => {
    handleLogout();
  }, []);
  return <></>;
};

export default Logout;
